import { render, staticRenderFns } from "./formGateway.vue?vue&type=template&id=3014a40b&scoped=true"
import script from "./formGateway.vue?vue&type=script&lang=js"
export * from "./formGateway.vue?vue&type=script&lang=js"
import style0 from "./formGateway.vue?vue&type=style&index=0&id=3014a40b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3014a40b",
  null
  
)

export default component.exports